import "./index.less";

if (!customElements.get("v5-pdp-scroll-pic-text")) {
  class V5PdpScrollPicText extends HTMLElement {
    constructor() {
      super();
      this.currentTab = 1;
      this.isMobile = window.innerWidth < 1024;
    }

    connectedCallback() {
      this.DOM = {
        tabParent: this.querySelector('.tabs') || null,
        tabs: this.querySelectorAll(".tab-btn") || [],
        contents: this.querySelectorAll(".tab-content-pc, .tab-content-mb") || [],
        videoButtons: this.querySelectorAll('[data-play-video]') || [],
        pcPlayVideos: this.querySelectorAll(`.pc-play-video`) || [],
        titles: this.querySelectorAll('.tab-content-pc .title') || [],
      };
      this.id = this.getAttribute("data-id");
      this.container = this.querySelector(`#${this.id}`);
      if(this.isMobile) {
        this.initMobile()
      } else {
        this.bindEvents();
        // Initialize the first frame active state
        this.initPcClickMode();
      }
      this.bindVideoEvent()
    }

    initPcClickMode() {
      const activeContent = this.querySelector(".tab-content-pc.active");
      if (!activeContent) return;
      this.activateFrame(0);
    }

    activateFrame(index) {
      const activeContent = this.querySelector(".tab-content-pc.active");
      if (!activeContent) return;

      const images = Array.from(activeContent.querySelectorAll(".scence-image"));
      const texts = Array.from(activeContent.querySelectorAll(".text-block"));
      const subs = texts.map((t) => t.querySelector(".sub-title"));

      // Switch Images
      images.forEach((img, i) => {
        img.style.transition = "opacity 0.4s ease";
        img.style.opacity = i === index ? "1" : "0";
        // Ensure only the active image is potentially clickable or interactive if needed
        img.style.zIndex = i === index ? "1" : "0";
      });

      // Switch Video Buttons
      const currentImage = images[index];
      const imageIndex = currentImage?.dataset.index;
      
      this.DOM.pcPlayVideos.forEach((item) => {
        // Only toggle videos inside the current active tab to avoid conflicts
        if (activeContent.contains(item)) {
            item.classList.remove("active");
        }
      });
      
      if (imageIndex) {
        const videoBtn = activeContent.querySelector(`.pc-play-video[data-index="${imageIndex}"]`);
        if (videoBtn) videoBtn.classList.add("active");
      }

      // Switch Text Active State & Accordion Animation
      texts.forEach((txt, ti) => {
        const isActive = ti === index;
        txt.classList.toggle("active", isActive);
        
        const sub = subs[ti];
        if (sub) {
            sub.style.transition = "max-height 0.4s ease, opacity 0.4s ease";
            if (isActive) {
                sub.style.opacity = "1"; // Match LESS .active .sub-title opacity
                sub.style.maxHeight = sub.scrollHeight + "px";
            } else {
                sub.style.opacity = "0"; // Or whatever inactive opacity is desired (LESS doesn't specify inactive opacity explicitly other than default)
                sub.style.maxHeight = "0px";
            }
        }
      });
    }

    // 移动端手风琴
    initMobile() {
      const titles = this.querySelectorAll('.mb-card-title');
      titles.forEach(title => {
        title.addEventListener('click', () => {
          const index = title.dataset.index;
          const card = this.querySelector(`.mb-card[data-index='${index}']`);
          card.classList.add('active')
          this.querySelectorAll('.mb-card').forEach(el => {
            if (el != card) el.classList.remove('active')
          })
        });
      });

      const tabs = this.querySelectorAll('.tab-btn-mb')
      tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => {
          const index = tab.dataset.index;
           if (index !== this.currentTab) {
              this.centerMobildTab(tabs, tab, i)
              this.switchMbTab(index);
           }
            
        })
      })
    }
    centerMobildTab(tabs, tab, index) {
      const container = this.querySelector('.mb-tabs');
      const containerWidth = container.clientWidth;
      const tabLeft = tab.offsetLeft;
      const tabWidth = tab.clientWidth;
      if(index === 0) {
        container.scrollTo({ left: 0, behavior: 'smooth' });
        return
      }

      if(index === tabs.length -1) {
        container.scrollTo({
          left: container.scrollWidth - containerWidth,
          behavior: "smooth",
        });
        return;
      }

      const targetLeft = tabLeft - containerWidth / 2 + tabWidth / 2;
      container.scrollTo({
        left: targetLeft,
        behavior: "smooth",
      });
    }
    switchMbTab(index) {
      this.querySelectorAll('.tab-btn-mb').forEach((tab) => {
        const isActive = tab.dataset.index === index;
        tab.classList.toggle("active", isActive);
        tab.classList.toggle("inactive", !isActive);
      });

      this.querySelectorAll('.tab-content-mb').forEach((c) =>
        c.classList.toggle("active", c.dataset.content === index)
      );
      const firstCard = this.querySelector('.tab-content-mb.active .mb-card');
      if (firstCard) {
        // 清除所有卡片 active
        this.querySelectorAll('.mb-card').forEach(card => {
          card.classList.remove('active');
        });
        // 只给第一个加
        firstCard.classList.add('active');
      }
    }

    bindEvents() {
      this.DOM.tabs.forEach((tab) => {
        tab.addEventListener("click", () => {
          const index = Number(tab.dataset.index);
          if (index !== this.currentTab) this.switchTabCommon(index);
        });
      });

      this.DOM.titles.forEach(title => {
        title.addEventListener('click', () => {
          const activeContent = this.querySelector(".tab-content-pc.active");
          if (!activeContent) return;
          
          const texts = Array.from(activeContent.querySelectorAll(".text-block"));
          const textBlock = title.closest('.text-block');
          const index = texts.indexOf(textBlock);
          
          if (index > -1) {
            this.activateFrame(index);
          }
        });
      });
    }

    setFirstMbCardActive() {
      const activeMb = this.querySelector(".tab-content-mb.active");
      if (!activeMb) return;
      const firstCard = activeMb.querySelector('.mb-card');
      if (firstCard) {
        activeMb.querySelectorAll('.mb-card').forEach(card => card.classList.remove('active'));
        firstCard.classList.add('active');
      }
    }

    bindVideoEvent() {
      this.DOM.videoButtons.forEach(videoButton => {
        videoButton.addEventListener('click', e => {
          console.log('click video')
          const el = e.target.closest('.video')
          const { video_id } = el.dataset
          const currEl = el.querySelector(`.video-${video_id}`)
          const dialog = document.createElement('jds-dialog'); 
          dialog.id = `dialog-video-${video_id}`; 
          dialog.classList.add('v5-video-dialog')
          dialog.style="--jds-dialog-width:75rem;--jds-dialog-index: 100002;"
          dialog.innerHTML = currEl.innerHTML;
          document.body.appendChild(dialog);
          dialog.addEventListener('jds-dialog-close', () => {
            dialog.remove();
          })
          // 打开弹窗
          dialog.setAttribute('open', true);})
      })
    }
    switchTabCommon(index) {
      this.currentTab = index;

      // UI 样式状态
      this.DOM.tabs.forEach((tab) => {
        const isActive = Number(tab.dataset.index) === index;
        tab.classList.toggle("active", isActive);
        tab.classList.toggle("inactive", !isActive);
      });

      this.DOM.contents.forEach((c) => {
        c.classList.toggle("active", Number(c.dataset.content) === index);
      });
      
      // PC: 初始化当前tab的第一个内容块
      const activePc = this.querySelector(".tab-content-pc.active");
      if (activePc) this.activateFrame(0);
      // MB: 保持首卡片默认展开
      this.setFirstMbCardActive();
    }
  }

  customElements.define("v5-pdp-scroll-pic-text", V5PdpScrollPicText);
}
